import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Row, Col, Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'

import { MANAGED_PAYMENT_ALLOWED_ROLES } from './utils'

/**
 * Management payment method
 * @param {object} props
 * @param {function} props.onEdit
 * @param {string} props.role
 */
function ManagementPaymentMethod(props) {
  const { role } = props

  const history = useHistory()
  const {
    paymentReferences, paymentMethod, _id: companyId
  } = useSelector(store => store.companies)

  const onClick = useCallback(
    () => {
      history.push(`/dashboard/management/company/${companyId}/payment/edit`)
    }, [companyId, history]
  )

  if (paymentMethod === 'wireTransfer') return null
  if (!MANAGED_PAYMENT_ALLOWED_ROLES.includes(role)) return null

  const existReferences = (paymentReferences || []).length > 0
  const isCreditCard = paymentMethod === 'creditCard' ? true : false
  const title = existReferences ? isCreditCard ? 'company_creditCardInfo' : 'company_configPaymentMethod' : 'dashboard_payment-method'
  const subtitle = existReferences ? isCreditCard ? 'credit_card_expiry_date' : 'company_configPaymentMethodDescription' : 'company_paymentMethodDescription'
  const buttonTitle = existReferences ? isCreditCard ? 'dashboard_modify-payment-method' : 'company_configPaymentMethod' : 'dashboard_add-payment-method'

  return (
    <>
      <Row className='mt-5'>
        <Col>
          <h1>{I18n.t(title)}</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className='my-3'>{I18n.t(subtitle)} {(existReferences && isCreditCard) ? <span>{paymentReferences[0].expiryDate}</span> : null}</div>
          <Button
            color='primary'
            onClick={onClick}
          >
            {I18n.t(buttonTitle)}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default ManagementPaymentMethod
